import { useRef } from "react";
import { Cast } from "./cast";
import { NotCast } from "./not-cast";
import * as Styled from "./style";
import { useProductInfo } from "~/components/blocks/product/common/blocks/product-tab-contents/product-info/use-product-info";
import { useHandleClickByDevice } from "~/hooks/use-handle-click-by-device";
import type { G_GetVideoQuery } from "~/lib/graphql";

export type ProductInfoProps = {
  /** videoクエリを叩いて取得したデータ */
  videoData: G_GetVideoQuery["video"];
};

/**
 * 作品情報を表示するコンポーネント
 * - 複数話・舞台・グラビア共通で必ず表示するTabContents
 * @param props {@link ProductInfoProps}
 */
export const ProductInfo = (props: ProductInfoProps) => {
  const { videoData } = props;

  const ref = useRef<HTMLDivElement>(null);

  const { handleClickByDevice } = useHandleClickByDevice();

  const {
    isOverTwentyInfo,
    isShowRemainingItems,
    scrollHeight,
    hasCastData,
    hasNotCastData,
    isGravure,
    onToggleShowRemainingItems,
  } = useProductInfo({
    ref,
    videoData,
  });

  return (
    <Styled.DivRootProductInfo
      ref={ref}
      isOverTwentyInfo={isOverTwentyInfo}
      isShowRemainingItems={isShowRemainingItems}
      scrollHeight={scrollHeight}
    >
      {hasCastData && <Cast videoData={videoData} hasNotCastData={hasNotCastData} isGravure={isGravure} />}

      {hasNotCastData && <NotCast videoData={videoData} hasCastData={hasCastData} isGravure={isGravure} />}

      {isOverTwentyInfo && (
        <Styled.ButtonWrapper
          type="button"
          name="Dropdown Button"
          aria-label="Dropdown Button"
          {...handleClickByDevice(onToggleShowRemainingItems)}
        >
          <Styled.Icon isShowRemainingItems={isShowRemainingItems} name="arrowDown" size="XXXL" />
        </Styled.ButtonWrapper>
      )}
    </Styled.DivRootProductInfo>
  );
};
